import Container from 'react-bootstrap/Container';
import styled from 'styled-components';

export const ChatMessagesContainer = styled(Container)`
    height: ${(props) => (props.height ? props.height : '200px')};
    overflow: auto;
`;
